// components/Charts/ProfitMarginChart.tsx
import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import type { ProfitMarginData } from "../../types/sales";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

interface Props {
  dataPoints: ProfitMarginData[];
}

const ProfitMarginChart: React.FC<Props> = ({ dataPoints }) => {
  const labels = useMemo(
    () => dataPoints.map((d) => d.label),
    [dataPoints]
  );

  console.log("Data: ", dataPoints);

  const data = useMemo(
    () => ({
      labels,
      datasets: [
        {
          label: "Revenue",
          data: dataPoints.map((d) => d.revenue),
          backgroundColor: "rgba(34,197,94,0.7)", // green
          borderRadius: 6,
        },
        {
          label: "Cost",
          data: dataPoints.map((d) => d.cost),
          backgroundColor: "rgba(239,68,68,0.7)", // red
          borderRadius: 6,
        },
      ],
    }),
    [labels, dataPoints]
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          afterBody: (items: any[]) => {
            const index = items[0].dataIndex;
            const point = dataPoints[index];
            return [
              `Profit: GHS ${(point.revenue - point.cost).toLocaleString()}`,
              `Margin: ${((point.revenue - point.cost)/100).toFixed(2)}%`,
            ];
          },
        },
      },
      legend: { position: "top" as const },
    },
    scales: {
      y: {
        beginAtZero: true,
       ticks: {
            callback: (value: any) => {
                const numeric =
                typeof value === "string" ? Number(value) : value;

                if (Number.isNaN(numeric)) return value;

                return `GHS ${numeric.toLocaleString()}`;
            },
        },

      },
    },
    
  };

  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm h-80">
      <div className="flex items-center justify-between mb-3">
        {/* <h3 className="text-lg font-semibold">Profit Margin</h3> */}
        <span className="text-sm text-gray-500">
          Revenue vs Cost
        </span>
      </div>

      <div className="h-64">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ProfitMarginChart;
